import { zodResolver } from '@hookform/resolvers/zod'
import { TPayouts } from '@lbs/shared-rp-types'
import { useForm } from 'react-hook-form'
import { RpPayoutsSchema, TRpPayoutsFormData } from './schema'

const defaultPayouts: TPayouts = [
  { combination: 'ROYAL_FLUSH', multiplier: 10 },
  { combination: 'STRAIGHT_FLUSH', multiplier: 9 },
  { combination: 'FOUR_OF_A_KIND', multiplier: 8 },
  { combination: 'FULL_HOUSE', multiplier: 7 },
  { combination: 'FLUSH', multiplier: 6 },
  { combination: 'STRAIGHT', multiplier: 5 },
  { combination: 'THREE_OF_A_KIND', multiplier: 4 },
  { combination: 'TWO_PAIRS', multiplier: 3 },
  { combination: 'ONE_PAIR', multiplier: 2 },
  { combination: 'ACE_KING', multiplier: 0 },
  { combination: 'HIGH_CARD', multiplier: 0 },
]

export const useRpPayoutsForm = () => {
  return useForm<TRpPayoutsFormData>({
    resolver: zodResolver(RpPayoutsSchema),
    defaultValues: {
      name: '',
      data: [...defaultPayouts],
    },
  })
}
